import { useMemo } from 'react'
import { useCurrentUser } from '@cma/app'
import { CmaPermissionIdEnum } from '@cma/generated/graphql'

type UseContentPermissionsReturn = {
  hasContentPermissions: boolean
}

export function useContentPermissions(): UseContentPermissionsReturn {
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMemo(() => {
    const userPermissions = currentUser?.permissions ?? []

    const permissionSet = new Set(
      userPermissions.map((permission) => permission.permissionId)
    )

    const hasContentPermissions = permissionSet.has(
      CmaPermissionIdEnum.CmaContentManage
    )

    return {
      hasContentPermissions
    }
  }, [currentUser?.permissions])
}
